/* @ngInject */

export default ($window, broadcastService, EVENT) => {
  /*
   * Event Emit Methods
   * --------------------------------------------------------------------------------
   */
  const accountAdd = (_args) => broadcastService.eventEmit(EVENT.ACCOUNT_ADD, _args);

  const accountDelete = (_args) => broadcastService.eventEmit(EVENT.ACCOUNT_DELETE, _args);

  const accountAvatarUpload = (_args) =>
    broadcastService.eventEmit(EVENT.ACCOUNT_AVATAR_UPLOAD, _args);

  const accountAvatarUploaded = (_args) =>
    broadcastService.eventEmit(EVENT.ACCOUNT_AVATAR_UPLOADED, _args);

  const accountPasswordChange = (_args) =>
    broadcastService.eventEmit(EVENT.ACCOUNT_PASSWORD_CHANGE, _args);

  const accountPasswordChanged = (_args) =>
    broadcastService.eventEmit(EVENT.ACCOUNT_PASSWORD_CHANGED, _args);

  const alertDialog = (_args) => broadcastService.eventEmit(EVENT.ALERT_DIALOG, _args);

  const assetFinanceProposalAmortizationScheduleChange = (_args) =>
    broadcastService.eventEmit(
      EVENT.ASSET_FINANCE_PROPOSAL_AMORTIZATION_SCHEDULE_CHANGE,
      _args
    );

  const assetFinanceQuickQuoteProcessing = (_args) =>
    broadcastService.eventEmit(EVENT.ASSET_FINANCE_QUICK_QUOTE_PROCESSING, _args);

  const assetDetailsAdditionalInfo = (_args) =>
    broadcastService.eventEmit(EVENT.ASSET_DETAILS_ADDITIONAL_INFO, _args);

  const attachmentEdit = (_args) => broadcastService.eventEmit(EVENT.ATTACHMENT_EDIT, _args);

  const attachmentRename = (_args) =>
    broadcastService.eventEmit(EVENT.ATTACHMENT_RENAME, _args);

  const campaignView = (_args) => broadcastService.eventEmit(EVENT.CAMPAIGN_VIEW, _args);

  const changedData = (_args) => broadcastService.eventEmit(EVENT.CHANGED_DATA, _args);

  const checklistEdit = (_args) => broadcastService.eventEmit(EVENT.CHECKLIST_EDIT, _args);

  const commissionEdit = (_args) => broadcastService.eventEmit(EVENT.COMMISSION_EDIT, _args);

  const confirmDialog = (_args) => broadcastService.eventEmit(EVENT.CONFIRM_DIALOG, _args);

  const connectToggle = (_args) => broadcastService.eventEmit(EVENT.CONNECT_TOGGLE, _args);

  const connectEvents = (_args) => broadcastService.eventEmit(EVENT.CONNECT_EVENTS, _args);

  const connectAccountOnline = (_args) =>
    broadcastService.eventEmit(EVENT.CONNECT_ACCOUNT_ONLINE, _args);

  const connectAccountOffline = (_args) =>
    broadcastService.eventEmit(EVENT.CONNECT_ACCOUNT_OFFLINE, _args);

  const connectOnline = (_args) => broadcastService.eventEmit(EVENT.CONNECT_ONLINE, _args);

  const connectOffline = (_args) => broadcastService.eventEmit(EVENT.CONNECT_OFFLINE, _args);

  const connectSms = (_args) => broadcastService.eventEmit(EVENT.CONNECT_SMS, _args);

  const connectSmsSent = (_args) => broadcastService.eventEmit(EVENT.CONNECT_SMS_SENT, _args);

  const connectSmsReceived = (_args) =>
    broadcastService.eventEmit(EVENT.CONNECT_SMS_RECEIVED, _args);

  const connectCall = (_args) => broadcastService.eventEmit(EVENT.CONNECT_CALL, _args);

  const connectCallSent = (_args) => broadcastService.eventEmit(EVENT.CONNECT_CALL_SENT, _args);

  const connectCallReceived = (_args) =>
    broadcastService.eventEmit(EVENT.CONNECT_CALL_RECEIVED, _args);

  const contactDelete = (_args) => broadcastService.eventEmit(EVENT.CONTACT_DELETE, _args);

  const credentialsChanged = (_args) =>
    broadcastService.eventEmit(EVENT.CREDENTIALS_CHANGED, _args);

  const credentialsExpiring = (_args) =>
    broadcastService.eventEmit(EVENT.CREDENTIALS_EXPIRING, _args);

  const dialogClientProfileVersionEdit = (_args) =>
    broadcastService.eventEmit(EVENT.DIALOG_CLIENT_PROFILE_VERSION_EDIT, _args);

  const dialogDeleteConfirmation = (_args) =>
    broadcastService.eventEmit(EVENT.DIALOG_DELETE_CONFIRMATION, _args);

  const dialogDiversificationReferralEdit = (_args) =>
    broadcastService.eventEmit(EVENT.DIALOG_DIVERSIFICATION_REFERRAL_EDIT, _args);

  const dialogESign = (_args) => broadcastService.eventEmit(EVENT.DIALOG_E_SIGN, _args);

  const dialogLabelSelect = (_args) =>
    broadcastService.eventEmit(EVENT.DIALOG_LABEL_SELECT, _args);

  const dialogStatusSelect = (_args) =>
    broadcastService.eventEmit(EVENT.DIALOG_STATUS_SELECT, _args);

  const dialogOpenBanking = (_args) =>
    broadcastService.eventEmit(EVENT.DIALOG_OPEN_BANKING, _args);

  const dialogSelectOption = (_args) =>
    broadcastService.eventEmit(EVENT.DIALOG_SELECT_OPTION, _args);

  const dialogUrlEdit = (_args) => broadcastService.eventEmit(EVENT.DIALOG_URL_EDIT, _args);

  const dialogTextEdit = (_args) => broadcastService.eventEmit(EVENT.DIALOG_TEXT_EDIT, _args);

  const documentAdd = (_args) => broadcastService.eventEmit(EVENT.DOCUMENT_ADD, _args);

  const documentRename = (_args) => broadcastService.eventEmit(EVENT.DOCUMENT_RENAME, _args);

  const driveUploadOrSync = (_args) =>
    broadcastService.eventEmit(EVENT.DRIVE_UPLOAD_OR_SYNC, _args);

  const emailSend = (_args) => broadcastService.eventEmit(EVENT.EMAIL_SEND, _args);

  const fieldEdit = (_args) => broadcastService.eventEmit(EVENT.FIELD_EDIT, _args);

  const filePreview = (_args) => broadcastService.eventEmit(EVENT.FILE_PREVIEW, _args);

  const formWarning = (_args) => broadcastService.eventEmit(EVENT.FORM_WARNING, _args);

  const groupsAndBranchesAdd = (_args) =>
    broadcastService.eventEmit(EVENT.GROUPS_AND_BRANCHES_ADD, _args);

  const groupsAndBranchesEdit = (_args) =>
    broadcastService.eventEmit(EVENT.GROUPS_AND_BRANCHES_EDIT, _args);

  const groupsAndBranchesMove = (_args) =>
    broadcastService.eventEmit(EVENT.GROUPS_AND_BRANCHES_MOVE, _args);

  const inputInsertValue = (_fieldName, _args) =>
    broadcastService.eventEmit(EVENT.INPUT_INSERT_VALUE + _fieldName, _args);

  const integrationErrors = (_args) =>
    broadcastService.eventEmit(EVENT.INTEGRATION_ERRORS, _args);

  const intercomHide = () => angular.element('.intercom-lightweight-app').hide();

  const intercomShow = () => angular.element('.intercom-lightweight-app').show();

  const jobEdit = (_args) => broadcastService.eventEmit(EVENT.JOB_EDIT, _args);

  const labelEdit = (_args) => broadcastService.eventEmit(EVENT.LABEL_EDIT, _args);

  const lenderDocumentLibrary = (_args) =>
    broadcastService.eventEmit(EVENT.LENDER_DOCUMENT_LIBRARY, _args);

  const lodgementResponseErrors = (_callback) =>
    broadcastService.eventEmit(EVENT.LODGEMENT_RESPONSE_ERROR, _callback);

  const marketingEdit = (_args) => broadcastService.eventEmit(EVENT.MARKETING_EDIT, _args);

  const mentorAssign = (_args) => broadcastService.eventEmit(EVENT.MENTOR_ASSIGN, _args);

  const mergeDocuments = (_args) => broadcastService.eventEmit(EVENT.MERGE_DOCUMENTS, _args);

  const messageEdit = (_args) => broadcastService.eventEmit(EVENT.MESSAGE_EDIT, _args);

  const messageEditTrigger = (_args) =>
    broadcastService.eventEmit(EVENT.MESSAGE_EDIT_TRIGGER, _args);

  const myConnectEdit = (_args) => broadcastService.eventEmit(EVENT.MY_CONNECT_EDIT, _args);

  const noteEdit = (_args) => broadcastService.eventEmit(EVENT.NOTE_EDIT, _args);

  const organizationAdd = (_args) => broadcastService.eventEmit(EVENT.ORGANIZATION_ADD, _args);

  const organizationChange = (_args) =>
    broadcastService.eventEmit(EVENT.ORGANIZATION_CHANGE, _args);

  const organizationLogoUpload = (_args) =>
    broadcastService.eventEmit(EVENT.ORGANIZATION_LOGO_UPLOAD, _args);

  const organizationLogoUploaded = (_args) =>
    broadcastService.eventEmit(EVENT.ORGANIZATION_LOGO_UPLOADED, _args);

  const partnerAssign = (_args) => broadcastService.eventEmit(EVENT.PARTNER_ASSIGN, _args);

  const phoneAssign = (_args) => broadcastService.eventEmit(EVENT.PHONE_ASSIGN, _args);

  const phoneRent = (_args) => broadcastService.eventEmit(EVENT.PHONE_RENT, _args);

  const phoneUnrent = (_args) => broadcastService.eventEmit(EVENT.PHONE_UNRENT, _args);

  const quickToolAssetFinanceQuickQuote = (_args) =>
    broadcastService.eventEmit(EVENT.QUICK_TOOL_ASSET_FINANCE_QUICK_QUOTE, _args);

  const quickToolAssetFinanceQuotingCalculator = (_args) =>
    broadcastService.eventEmit(EVENT.QUICK_TOOL_ASSET_FINANCE_QUOTING_CALCULATOR, _args);

  const quickToolHomeLoanFundingWorksheet = (_args) =>
    broadcastService.eventEmit(EVENT.QUICK_TOOL_HOME_LOAN_FUNDING_WORKSHEET, _args);

  const quickToolHomeLoanMaximumBorrowing = (_args) =>
    broadcastService.eventEmit(EVENT.QUICK_TOOL_HOME_LOAN_MAXIMUM_BORROWING, _args);

  const quickToolHomeLoanCompareProducts = (_args) =>
    broadcastService.eventEmit(EVENT.QUICK_TOOL_HOME_LOAN_COMPARE_PRODUCTS, _args);

  const quickToolHomeLoanRefinanceAnalysis = (_args) =>
    broadcastService.eventEmit(EVENT.QUICK_TOOL_HOME_LOAN_REFINANCE_ANALYSIS, _args);

  const reportsOpen = (_args) => broadcastService.eventEmit(EVENT.REPORTS_OPEN, _args);

  const reportsClose = (_args) => broadcastService.eventEmit(EVENT.REPORTS_CLOSE, _args);

  const refreshPropertyAdditionalData = (_args) =>
    broadcastService.eventEmit(EVENT.RP_DATA_PROPERTY_REFRESH_DATA, _args);

  const scriptEdit = (_args) => broadcastService.eventEmit(EVENT.SCRIPT_EDIT, _args);

  const ticketViewContactAdd = (_args) =>
    broadcastService.eventEmit(EVENT.TICKET_VIEW_CONTACT_ADD, _args);

  const toggleConnection = (_args) =>
    broadcastService.eventEmit(EVENT.TOGGLE_CONNECTION, _args);

  const videoConferenceInvite = (_args) =>
    broadcastService.eventEmit(EVENT.VIDEO_CONFERENCE_INVITE, _args);

  const workflowDelete = (_args) => broadcastService.eventEmit(EVENT.WORKFLOW_DELETE, _args);

  const workflowTicketMove = (_args) =>
    broadcastService.eventEmit(EVENT.WORKFLOW_TICKET_MOVE, _args);

  /*
   * Event Receive Methods
   * --------------------------------------------------------------------------------
   */
  const onAccountAdd = (_callback) =>
    broadcastService.eventReceive(EVENT.ACCOUNT_ADD, _callback);

  const onAccountDelete = (_callback) =>
    broadcastService.eventReceive(EVENT.ACCOUNT_DELETE, _callback);

  const onAccountAvatarUpload = (_callback) =>
    broadcastService.eventReceive(EVENT.ACCOUNT_AVATAR_UPLOAD, _callback);

  const onAccountAvatarUploaded = (_callback) =>
    broadcastService.eventReceive(EVENT.ACCOUNT_AVATAR_UPLOADED, _callback);

  const onAccountPasswordChange = (_callback) =>
    broadcastService.eventReceive(EVENT.ACCOUNT_PASSWORD_CHANGE, _callback);

  const onAccountPasswordChanged = (_callback) =>
    broadcastService.eventReceive(EVENT.ACCOUNT_PASSWORD_CHANGED, _callback);

  const onAlertDialog = (_callback) =>
    broadcastService.eventReceive(EVENT.ALERT_DIALOG, _callback);

  const onAssetFinanceProposalAmortizationScheduleChange = (_callback) =>
    broadcastService.eventReceive(
      EVENT.ASSET_FINANCE_PROPOSAL_AMORTIZATION_SCHEDULE_CHANGE,
      _callback
    );
  const onAssetFinanceQuickQuoteProcessing = (_callback) =>
    broadcastService.eventReceive(EVENT.ASSET_FINANCE_QUICK_QUOTE_PROCESSING, _callback);

  const onAssetDetailsAdditionalInfo = (_callback) =>
    broadcastService.eventReceive(EVENT.ASSET_DETAILS_ADDITIONAL_INFO, _callback);

  const onAttachmentEdit = (_callback) =>
    broadcastService.eventReceive(EVENT.ATTACHMENT_EDIT, _callback);

  const onAttachmentRename = (_callback) =>
    broadcastService.eventReceive(EVENT.ATTACHMENT_RENAME, _callback);

  const onCampaignView = (_callback) =>
    broadcastService.eventReceive(EVENT.CAMPAIGN_VIEW, _callback);

  const onChangedData = (_callback) =>
    broadcastService.eventReceive(EVENT.CHANGED_DATA, _callback);

  const onChecklistEdit = (_callback) =>
    broadcastService.eventReceive(EVENT.CHECKLIST_EDIT, _callback);

  const onCommissionEdit = (_callback) =>
    broadcastService.eventReceive(EVENT.COMMISSION_EDIT, _callback);

  const onConfirmDialog = (_callback) =>
    broadcastService.eventReceive(EVENT.CONFIRM_DIALOG, _callback);

  const onConnectToggle = (_callback) =>
    broadcastService.eventReceive(EVENT.CONNECT_TOGGLE, _callback);

  const onConnectEvents = (_callback) =>
    broadcastService.eventReceive(EVENT.CONNECT_EVENTS, _callback);

  const onConnectOnline = (_callback) =>
    broadcastService.eventReceive(EVENT.CONNECT_ONLINE, _callback);

  const onConnectOffline = (_callback) =>
    broadcastService.eventReceive(EVENT.CONNECT_OFFLINE, _callback);

  const onConnectAccountOnline = (_callback) =>
    broadcastService.eventReceive(EVENT.CONNECT_ACCOUNT_ONLINE, _callback);

  const onConnectAccountOffline = (_callback) =>
    broadcastService.eventReceive(EVENT.CONNECT_ACCOUNT_OFFLINE, _callback);

  const onConnectSms = (_callback) =>
    broadcastService.eventReceive(EVENT.CONNECT_SMS, _callback);

  const onConnectSmsSent = (_callback) =>
    broadcastService.eventReceive(EVENT.CONNECT_SMS_SENT, _callback);

  const onConnectSmsReceived = (_callback) =>
    broadcastService.eventReceive(EVENT.CONNECT_SMS_RECEIVED, _callback);

  const onConnectCall = (_callback) =>
    broadcastService.eventReceive(EVENT.CONNECT_CALL, _callback);

  const onConnectCallSent = (_callback) =>
    broadcastService.eventReceive(EVENT.CONNECT_CALL_SENT, _callback);

  const onConnectCallReceived = (_callback) =>
    broadcastService.eventReceive(EVENT.CONNECT_CALL_RECEIVED, _callback);

  const onCredentialsChanged = (_callback) =>
    broadcastService.eventReceive(EVENT.CREDENTIALS_CHANGED, _callback);

  const onCredentialsExpiring = (_callback) =>
    broadcastService.eventReceive(EVENT.CREDENTIALS_EXPIRING, _callback);

  const onContactDeleted = (_callback) =>
    broadcastService.eventReceive(EVENT.CONTACT_DELETE, _callback);

  const onDialogClientProfileVersionEdit = (_callback) =>
    broadcastService.eventReceive(EVENT.DIALOG_CLIENT_PROFILE_VERSION_EDIT, _callback);

  const onDialogDiversificationReferralEdit = (_callback) =>
    broadcastService.eventReceive(EVENT.DIALOG_DIVERSIFICATION_REFERRAL_EDIT, _callback);

  const onDialogDeleteConfirmation = (_callback) =>
    broadcastService.eventReceive(EVENT.DIALOG_DELETE_CONFIRMATION, _callback);

  const onDialogESign = (_callback) =>
    broadcastService.eventReceive(EVENT.DIALOG_E_SIGN, _callback);

  const onDialogLabelSelect = (_callback) =>
    broadcastService.eventReceive(EVENT.DIALOG_LABEL_SELECT, _callback);

  const onDialogStatusSelect = (_callback) =>
    broadcastService.eventReceive(EVENT.DIALOG_STATUS_SELECT, _callback);

  const onDialogOpenBanking = (_callback) =>
    broadcastService.eventReceive(EVENT.DIALOG_OPEN_BANKING, _callback);

  const onDialogSelectOption = (_callback) =>
    broadcastService.eventReceive(EVENT.DIALOG_SELECT_OPTION, _callback);

  const onDialogUrlEdit = (_callback) =>
    broadcastService.eventReceive(EVENT.DIALOG_URL_EDIT, _callback);

  const onDialogTextEdit = (_callback) =>
    broadcastService.eventReceive(EVENT.DIALOG_TEXT_EDIT, _callback);

  const onDocumentAdd = (_callback) =>
    broadcastService.eventReceive(EVENT.DOCUMENT_ADD, _callback);

  const onDocumentRename = (_callback) =>
    broadcastService.eventReceive(EVENT.DOCUMENT_RENAME, _callback);

  const onDriveUploadOrSync = (_callback) =>
    broadcastService.eventReceive(EVENT.DRIVE_UPLOAD_OR_SYNC, _callback);

  const onEmailSend = (_callback) => broadcastService.eventReceive(EVENT.EMAIL_SEND, _callback);

  const onFieldEdit = (_callback) => broadcastService.eventReceive(EVENT.FIELD_EDIT, _callback);

  const onFilePreview = (_callback) =>
    broadcastService.eventReceive(EVENT.FILE_PREVIEW, _callback);

  const onFormWarning = (_callback) =>
    broadcastService.eventReceive(EVENT.FORM_WARNING, _callback);

  const onGroupsAndBranchesAdd = (_callback) =>
    broadcastService.eventReceive(EVENT.GROUPS_AND_BRANCHES_ADD, _callback);

  const onGroupsAndBranchesEdit = (_callback) =>
    broadcastService.eventReceive(EVENT.GROUPS_AND_BRANCHES_EDIT, _callback);

  const onGroupsAndBranchesMove = (_callback) =>
    broadcastService.eventReceive(EVENT.GROUPS_AND_BRANCHES_MOVE, _callback);

  const onInputInsertValue = (_fieldName, _callback) =>
    broadcastService.eventReceive(EVENT.INPUT_INSERT_VALUE + _fieldName, _callback);

  const onIntegrationErrors = (_callback) =>
    broadcastService.eventReceive(EVENT.INTEGRATION_ERRORS, _callback);

  const onJobEdit = (_callback) => broadcastService.eventReceive(EVENT.JOB_EDIT, _callback);

  const onLabelEdit = (_callback) => broadcastService.eventReceive(EVENT.LABEL_EDIT, _callback);

  const onLenderDocumentLibrary = (_callback) =>
    broadcastService.eventReceive(EVENT.LENDER_DOCUMENT_LIBRARY, _callback);

  const onLodgementResponseErrors = (_callback) =>
    broadcastService.eventReceive(EVENT.LODGEMENT_RESPONSE_ERROR, _callback);

  const onMarketingEdit = (_callback) =>
    broadcastService.eventReceive(EVENT.MARKETING_EDIT, _callback);

  const onMentorAssign = (_callback) =>
    broadcastService.eventReceive(EVENT.MENTOR_ASSIGN, _callback);

  const onMergeDocuments = (_callback) =>
    broadcastService.eventReceive(EVENT.MERGE_DOCUMENTS, _callback);

  const onMessageEdit = (_callback) =>
    broadcastService.eventReceive(EVENT.MESSAGE_EDIT, _callback);

  const onMessageEditTrigger = (_callback) =>
    broadcastService.eventReceive(EVENT.MESSAGE_EDIT_TRIGGER, _callback);

  const onMyConnectEdit = (_args) =>
    broadcastService.eventReceive(EVENT.MY_CONNECT_EDIT, _args);

  const onNoteEdit = (_callback) => broadcastService.eventReceive(EVENT.NOTE_EDIT, _callback);

  const onOrganizationAdd = (_callback) =>
    broadcastService.eventReceive(EVENT.ORGANIZATION_ADD, _callback);

  const onOrganizationChange = (_callback) =>
    broadcastService.eventReceive(EVENT.ORGANIZATION_CHANGE, _callback);

  const onOrganizationLogoUpload = (_callback) =>
    broadcastService.eventReceive(EVENT.ORGANIZATION_LOGO_UPLOAD, _callback);

  const onOrganizationLogoUploaded = (_callback) =>
    broadcastService.eventReceive(EVENT.ORGANIZATION_LOGO_UPLOADED, _callback);

  const onPartnerAssign = (_callback) =>
    broadcastService.eventReceive(EVENT.PARTNER_ASSIGN, _callback);

  const onPhoneAssign = (_callback) =>
    broadcastService.eventReceive(EVENT.PHONE_ASSIGN, _callback);

  const onPhoneRent = (_callback) => broadcastService.eventReceive(EVENT.PHONE_RENT, _callback);

  const onPhoneUnrent = (_callback) =>
    broadcastService.eventReceive(EVENT.PHONE_UNRENT, _callback);

  const onQuickToolAssetFinanceQuickQuote = (_callback) =>
    broadcastService.eventReceive(EVENT.QUICK_TOOL_ASSET_FINANCE_QUICK_QUOTE, _callback);

  const onQuickToolAssetFinanceQuotingCalculator = (_callback) =>
    broadcastService.eventReceive(EVENT.QUICK_TOOL_ASSET_FINANCE_QUOTING_CALCULATOR, _callback);

  const onQuickToolHomeLoanFundingWorksheet = (_callback) =>
    broadcastService.eventReceive(EVENT.QUICK_TOOL_HOME_LOAN_FUNDING_WORKSHEET, _callback);

  const onQuickToolHomeLoanMaximumBorrowing = (_callback) =>
    broadcastService.eventReceive(EVENT.QUICK_TOOL_HOME_LOAN_MAXIMUM_BORROWING, _callback);

  const onQuickToolHomeLoanCompareProducts = (_callback) =>
    broadcastService.eventReceive(EVENT.QUICK_TOOL_HOME_LOAN_COMPARE_PRODUCTS, _callback);

  const onQuickToolHomeLoanRefinanceAnalysis = (_callback) =>
    broadcastService.eventReceive(EVENT.QUICK_TOOL_HOME_LOAN_REFINANCE_ANALYSIS, _callback);

  const onReportsOpen = (_callback) =>
    broadcastService.eventReceive(EVENT.REPORTS_OPEN, _callback);

  const onReportsClose = (_callback) =>
    broadcastService.eventReceive(EVENT.REPORTS_CLOSE, _callback);

  const onRefreshPropertyAdditionalData = (_callback) =>
    broadcastService.eventReceive(EVENT.RP_DATA_PROPERTY_REFRESH_DATA, _callback);

  const onScriptEdit = (_callback) =>
    broadcastService.eventReceive(EVENT.SCRIPT_EDIT, _callback);

  const onTicketViewContactAdd = (_callback) =>
    broadcastService.eventReceive(EVENT.TICKET_VIEW_CONTACT_ADD, _callback);

  const onToggleConnection = (_callback) =>
    broadcastService.eventReceive(EVENT.TOGGLE_CONNECTION, _callback);

  const onVideoConferenceInvite = (_callback) =>
    broadcastService.eventReceive(EVENT.VIDEO_CONFERENCE_INVITE, _callback);

  const onWorkflowDelete = (_callback) =>
    broadcastService.eventReceive(EVENT.WORKFLOW_DELETE, _callback);

  const onWorkflowTicketMove = (_callback) =>
    broadcastService.eventReceive(EVENT.WORKFLOW_TICKET_MOVE, _callback);

  return {
    accountAdd,
    accountDelete,
    accountAvatarUpload,
    accountAvatarUploaded,
    accountPasswordChange,
    accountPasswordChanged,
    alertDialog,
    assetFinanceProposalAmortizationScheduleChange,
    assetFinanceQuickQuoteProcessing,
    assetDetailsAdditionalInfo,
    attachmentEdit,
    attachmentRename,
    campaignView,
    changedData,
    checklistEdit,
    commissionEdit,
    confirmDialog,
    connectToggle,
    connectEvents,
    connectOnline,
    connectOffline,
    connectAccountOnline,
    connectAccountOffline,
    connectSms,
    connectSmsSent,
    connectSmsReceived,
    connectCall,
    connectCallSent,
    connectCallReceived,
    contactDelete,
    credentialsChanged,
    credentialsExpiring,
    dialogClientProfileVersionEdit,
    dialogDiversificationReferralEdit,
    dialogDeleteConfirmation,
    dialogESign,
    dialogLabelSelect,
    dialogStatusSelect,
    dialogOpenBanking,
    dialogSelectOption,
    dialogUrlEdit,
    dialogTextEdit,
    documentAdd,
    documentRename,
    driveUploadOrSync,
    emailSend,
    fieldEdit,
    filePreview,
    formWarning,
    groupsAndBranchesAdd,
    groupsAndBranchesEdit,
    groupsAndBranchesMove,
    inputInsertValue,
    integrationErrors,
    intercomHide,
    intercomShow,
    jobEdit,
    labelEdit,
    lodgementResponseErrors,
    lenderDocumentLibrary,
    marketingEdit,
    mentorAssign,
    mergeDocuments,
    messageEdit,
    messageEditTrigger,
    myConnectEdit,
    noteEdit,
    organizationAdd,
    organizationChange,
    organizationLogoUpload,
    organizationLogoUploaded,
    partnerAssign,
    phoneAssign,
    phoneRent,
    phoneUnrent,
    quickToolAssetFinanceQuickQuote,
    quickToolAssetFinanceQuotingCalculator,
    quickToolHomeLoanFundingWorksheet,
    quickToolHomeLoanMaximumBorrowing,
    quickToolHomeLoanCompareProducts,
    quickToolHomeLoanRefinanceAnalysis,
    reportsOpen,
    reportsClose,
    refreshPropertyAdditionalData,
    scriptEdit,
    ticketViewContactAdd,
    toggleConnection,
    videoConferenceInvite,
    workflowTicketMove,
    workflowDelete,
    onAccountAdd,
    onAccountDelete,
    onAccountAvatarUpload,
    onAccountAvatarUploaded,
    onAccountPasswordChange,
    onAccountPasswordChanged,
    onAlertDialog,
    onAssetFinanceProposalAmortizationScheduleChange,
    onAssetFinanceQuickQuoteProcessing,
    onAssetDetailsAdditionalInfo,
    onAttachmentEdit,
    onAttachmentRename,
    onCampaignView,
    onChangedData,
    onChecklistEdit,
    onCommissionEdit,
    onConfirmDialog,
    onConnectToggle,
    onConnectEvents,
    onConnectOnline,
    onConnectOffline,
    onConnectAccountOnline,
    onConnectAccountOffline,
    onConnectSms,
    onConnectSmsSent,
    onConnectSmsReceived,
    onConnectCall,
    onConnectCallSent,
    onConnectCallReceived,
    onContactDeleted,
    onCredentialsChanged,
    onCredentialsExpiring,
    onDialogClientProfileVersionEdit,
    onDialogDiversificationReferralEdit,
    onDialogDeleteConfirmation,
    onDialogESign,
    onDialogLabelSelect,
    onDialogStatusSelect,
    onDialogOpenBanking,
    onDialogSelectOption,
    onDialogUrlEdit,
    onDialogTextEdit,
    onDocumentAdd,
    onDocumentRename,
    onDriveUploadOrSync,
    onEmailSend,
    onFieldEdit,
    onFilePreview,
    onFormWarning,
    onGroupsAndBranchesAdd,
    onGroupsAndBranchesEdit,
    onGroupsAndBranchesMove,
    onInputInsertValue,
    onIntegrationErrors,
    onJobEdit,
    onLabelEdit,
    onLenderDocumentLibrary,
    onLodgementResponseErrors,
    onMarketingEdit,
    onMentorAssign,
    onMergeDocuments,
    onMessageEdit,
    onMessageEditTrigger,
    onMyConnectEdit,
    onNoteEdit,
    onOrganizationAdd,
    onOrganizationChange,
    onOrganizationLogoUpload,
    onOrganizationLogoUploaded,
    onPartnerAssign,
    onPhoneAssign,
    onPhoneRent,
    onPhoneUnrent,
    onQuickToolAssetFinanceQuickQuote,
    onQuickToolAssetFinanceQuotingCalculator,
    onQuickToolHomeLoanFundingWorksheet,
    onQuickToolHomeLoanMaximumBorrowing,
    onQuickToolHomeLoanCompareProducts,
    onQuickToolHomeLoanRefinanceAnalysis,
    onReportsOpen,
    onReportsClose,
    onRefreshPropertyAdditionalData,
    onScriptEdit,
    onTicketViewContactAdd,
    onToggleConnection,
    onVideoConferenceInvite,
    onWorkflowDelete,
    onWorkflowTicketMove
  };
};
